import * as React from 'react';
import { motion } from 'framer-motion';
import styled, { useTheme } from 'styled-components';

import useMediaQuery from '@/utils/useMediaQuery';

export const GRID_SIZE = 32;

const Wrapper = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
`;

const Wide = styled.div`
  display: flex;
  justify-content: space-between;
  height: ${GRID_SIZE}px;
  position: absolute;
  left: ${GRID_SIZE}px;
  right: ${GRID_SIZE}px;
  border-left: 1px solid ${({ theme }) => theme.borderColor.MUTED};
  border-right: 1px solid ${({ theme }) => theme.borderColor.MUTED};
  box-sizing: content-box;
`;

const Side = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: ${GRID_SIZE}px;
  position: absolute;
  top: ${GRID_SIZE}px;
  left: auto;
  right: auto;
  bottom: ${GRID_SIZE}px;
  border-top: 1px solid ${({ theme }) => theme.borderColor.MUTED};
  border-bottom: 1px solid ${({ theme }) => theme.borderColor.MUTED};
  border-right: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
  border-left: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
  box-sizing: content-box;
`;

const Top = styled(Wide)`
  top: 0;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
`;

const Bottom = styled(Wide)`
  bottom: 0;
  border-top: 1px solid ${({ theme }) => theme.borderColor.DEFAULT};
`;

const Left = styled(Side)`
  left: 0;
  border-left: none;
`;

const Right = styled(Side)`
  right: 0;
  border-right: none;
`;

const VerticalLine = styled.div`
  width: 1px;
  background: ${({ theme }) => theme.borderColor.MUTED};
  flex: none;
`;

const HorizLine = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.borderColor.MUTED};
  flex: none;
`;

export const PaperGrid: React.ComponentType = React.memo(() => {
  const theme = useTheme();
  const shouldCollapse = useMediaQuery(theme.mediaQueryString.SMALL);

  const wideContents = (
    <>
      <div />
      <VerticalLine />
      <div />
      <VerticalLine />
      <div />
      <VerticalLine />
      <div />
      <VerticalLine />
      <div />
    </>
  );

  const sideContents = (
    <>
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
      <HorizLine />
      <div />
    </>
  );

  if (shouldCollapse) {
    return null;
  }

  return (
    <Wrapper>
      <Top>{wideContents}</Top>
      <Left>{sideContents}</Left>
      <Right>{sideContents}</Right>
      <Bottom>{wideContents}</Bottom>
    </Wrapper>
  );
});
